module.exports = __webpack_public_path__ + "img/home-6-mobileperson.a00dd9ac.png";